import { render } from "./DoctorDayEditModal.vue?vue&type=template&id=48cd1e6d"
import script from "./DoctorDayEditModal.vue?vue&type=script&lang=js"
export * from "./DoctorDayEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__